/**
 * About Stroyma Page
 */

import { createFooter } from '../components/footer.js';
import { createNavigation } from '../components/navigation.js';
import { t } from '../lib/i18n.js';

export async function renderAbout() {
  const app = document.getElementById('app');
  app.innerHTML = '';

  // Navigation
  app.appendChild(await createNavigation());

  // Page Content
  const content = document.createElement('section');
  content.className = 'section';
  content.style.paddingTop = '100px';
  content.style.paddingBottom = '80px';
  content.innerHTML = `
    <div class="container">
      <div class="about-page">
        <h1 class="about-title">${t('about_title')}</h1>
        
        <div class="about-content">
          <div class="about-section">
            <h2>${t('about_section_1_title')}</h2>
            ${t('about_section_1_content')}
          </div>

          <div class="about-section">
            <h2>${t('about_section_2_title')}</h2>
            ${t('about_section_2_content')}
          </div>

          <div class="about-section">
            <h2>${t('about_section_3_title')}</h2>
            ${t('about_section_3_content')}
          </div>

          <div class="about-section">
            <h2>${t('about_section_4_title')}</h2>
            ${t('about_section_4_content')}
          </div>
        </div>
        
        <div class="about-back">
          <a href="/" class="btn btn-secondary" data-link>${t('legal_back_home')}</a>
        </div>
      </div>
    </div>
  `;
  app.appendChild(content);

  // Footer
  app.appendChild(createFooter());
}
